/* eslint-disable @typescript-eslint/no-explicit-any */
import { BASE_API } from '../utils/constants'
import { getAccessToken } from '../utils/getAlefuser'
import { getSelectedOrganization } from '../utils/selectedOrganization'

const getAdditionalDetails = async ({ fieldName, oldValue, newValue }): Promise<{ type: string; oldValue: any; newValue: any }> => {
  try {
    const req = await fetch(`${BASE_API}/audit/search/details`, {
      headers: {
        authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json',
        'X-Tenantid': getSelectedOrganization()
      },
      method: 'POST',
      body: JSON.stringify({
        fieldName,
        oldValue: oldValue || [],
        newValue: newValue || []
      })
    })
    if (req.status !== 200) {
      throw new Error('request Error')
    }
    const data = await req.json()
    return data
  } catch (e) {
    console.error(e)
    return {
      type: fieldName,
      oldValue: oldValue,
      newValue: newValue
    }
  }
}

export default getAdditionalDetails
